import actions from './actions'
import mutations from './mutation'

const state = {
  root_list: [],
  root_paging: {
    offset: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  org_list: [],
  org_paging: {
    offset: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  node_list: [],
  node_paging: {
    offset: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  user_list: [],
  user_paging: {
    offset: 0,
    limit: 10,
    total: 0,
    totalPages: 0
  }
}

export default {
  state,
  actions,
  mutations
}
